import { render, staticRenderFns } from "./CurrencyUpdateModals.vue?vue&type=template&id=54814871&"
import script from "./CurrencyUpdateModals.vue?vue&type=script&lang=js&"
export * from "./CurrencyUpdateModals.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyUpdateModals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports